import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

export function LineItemsIsStackableQuestionBubble() {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">Stackable</T>
          <T size="xs" color="secondary">
            Is your freight stackable? Allowing freight to be stacked can
            greatly increase the risk of damages, however in some circumstances
            it might lead to lower prices.
          </T>
          <T size="xs" color="secondary">
            If in doubt, we recommend marking it as not stackable.
          </T>
          <Link
            href="https://help.freightsimple.com/using-freightsimple/quoting/shipment-contents#stackable"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
}
